module.exports = __webpack_public_path__ + "img/sld_mppt_1_t1_green.4dfed203.svg";